import React from "react";
import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoutes";
import Page404 from "./components/Auth/Page404";
import SignIn from "./components/Auth/SignIn";
import ProductList from "./screens/Product/ProductList";
import Dashboard from "./screens/Dashboard/Dashboard";
import AddDynamicForm from "./screens/Product/AddDynamicForm";
import PublicRoute from "./PublicRoutes";
// import CompanyList from "./screens/Company/CompanyList";
import AddScoreForm from "./screens/DecisionTree/AddScoreForm";
import UserDetailsView from "./screens/Product/UserDetailsView";

import OnboardingQuestionList from "./screens/OnboardingQuestions/QuestionList.js";
import AddOnboardingQuestion from "./screens/OnboardingQuestions/CreateQuestion.js";

import MeditationCatList from "./screens/MeditationCat/CatList.js";
import AddMeditationCat from "./screens/MeditationCat/CreateCat.js";


import DailyCheckinQuestionList from "./screens/DailyQuestions/QuestionList.js";
import AddCheckinQuestionList from "./screens/DailyQuestions/CreateQuestion.js";
import FaqList from "./screens/Faq/FaqList";
import CreateFaq from "./screens/Faq/CreateFaq";
import TermsAndCondition from "./screens/Cms/TermsAndCondition.js";
import PrivacyPolicy from "./screens/Cms/PrivacyPolicy.js";
import AboutUsPage from "./screens/Cms/Aboutus.js";
import BlogList from "./screens/Blogs/BlogList";
import CreateBlog from "./screens/Blogs/CreateBlog";
import ResourceList from "./screens/Resources/ResourceList";
import CreateResource from "./screens/Resources/CreateResource";
import MeditationSeriesList from "./screens/MeditationSeries/MeditationSeriesList";
import CreateMeditationSeries from "./screens/MeditationSeries/CreateMeditationSeries";
import MeditationPlaylist from "./screens/MeditationPlaylist/Playlist.js";
import CreateMeditationPlaylist from "./screens/MeditationPlaylist/CreatePlaylist.js";
import PlanList from "./screens/Plan/PlanList.js";
import CreatePlan from "./screens/Plan/CreatePlan.js";
import PostList from "./screens/Posts/PostsList.js";
import CreatePost from "./screens/Posts/CreatePost.js";
import Sleepstorieslist from "./screens/SleepStories/StoriesList.js";
import CreateSleepStory from "./screens/SleepStories/CreateStory.js";
import ScreenList from "./screens/IntroScreen/ScreenList.js";
import CreateScreen from "./screens/IntroScreen/CreateScreen.js";
import JournalsList from "./screens/Journals/JournalList.js";
import MusicList from "./screens/MeditationBackgroundMusic/MusicList.js";
import CreateMusic from "./screens/MeditationBackgroundMusic/CreateMusic.js";
import SubscriptionList from "./screens/Subscriptions/SubscriptionList";

const App = () => {

  return (
    <Routes>
        <Route
          element={
            <ProtectedRoute />
          }
        >
          {/* Protected routes for Admin */}
          <Route path="/" element={<ProductList />} />
          {/* <Route path="/company-list" element={<CompanyList />} />
          <Route path="/sector-list" element={<SectorList />} /> */}
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/user-list" element={<ProductList />} />
          <Route path="/onboarding-questions" element={<OnboardingQuestionList />} />
          <Route path="/add-onboarding-question" element={<AddOnboardingQuestion />} />
          <Route path="/add-onboarding-question/:id" element={<AddOnboardingQuestion />} />

          <Route path="/daily-checkin-questions" element={<DailyCheckinQuestionList />} />
          <Route path="/add-checkin-questions" element={<AddCheckinQuestionList />} />
          <Route path="/edit-checkin-questions/:id" element={<AddCheckinQuestionList />} />

          <Route path="/meditation-categories" element={<MeditationCatList />} />
          <Route path="/add-meditation-category" element={<AddMeditationCat />} />
          <Route path="/add-meditation-category/:id" element={<AddMeditationCat />} />

          
          {/* <Route path="/add-onboarding-question" element={<AddOnboardingQuestion />} />
          <Route path="/add-onboarding-question/:id" element={<AddOnboardingQuestion />} /> */}
          {/* <Route path="/onboarding-questions" element={<OnboardingQuestionList />} /> */}
          {/* <Route path="/create-recipe" element={<CreateRecipe />} />
          <Route path="/create-recipe/:id" element={<CreateRecipe />} /> */}
          {/* <Route path="/video-list" element={<VideoList />} />
          <Route path="/create-video" element={<CreateVideo />} />
          <Route path="/create-video/:id" element={<CreateVideo />} />
          <Route path="/plan-list" element={<PlanList />} />
          <Route path="/create-plan" element={<CreatePlan />} />
          <Route path="/create-plan/:id" element={<CreatePlan />} />
         
          
          
          <Route path="/medical-disclaimer" element={<MedicalDisclaimer />} />
          
          <Route path="/user-details/:id" element={<UserDetailsView />} /> */}
          {/* <Route path="/help-support" element={<QueryList />} /> */}
          <Route path="/faq-list" element={<FaqList />} />
          <Route path="/user-details/:id" element={<UserDetailsView />} />
          <Route path="/create-faq" element={<CreateFaq />} />
          <Route path="/create-faq/:id" element={<CreateFaq />} />
          <Route path="/terms-and-conditions" element={<TermsAndCondition />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/about-us" element={<AboutUsPage />} />

          <Route path="/blog-list" element={<BlogList />} />
          <Route path="/create-blog" element={<CreateBlog />} />
          <Route path="/create-blog/:id" element={<CreateBlog />} />
          <Route path="/resource-list" element={<ResourceList />} />
          <Route path="/create-resource" element={<CreateResource />} />
          <Route path="/edit-resource/:id" element={<CreateResource />} />
          <Route path="/meditation-series-list" element={<MeditationSeriesList />} />
          <Route path="/create-meditation-series" element={<CreateMeditationSeries />} />
          <Route path="/edit-meditation-series/:id" element={<CreateMeditationSeries />} />
          <Route path="/meditation-playlist" element={<MeditationPlaylist />} />
          <Route path="/create-meditation-playlist" element={<CreateMeditationPlaylist />} />
          <Route path="/edit-meditation-playlist/:id" element={<CreateMeditationPlaylist />} />
          <Route path="/plan-list" element={<PlanList />} />
          <Route path="/create-plan" element={<CreatePlan />} />
          <Route path="/create-plan/:id" element={<CreatePlan />} />
          <Route path="/posts-list" element={<PostList />} />
          <Route path="/create-post" element={<CreatePost />} />
          <Route path="/edit-post/:id" element={<CreatePost />} />
          <Route path="/sleep-stories-list" element={<Sleepstorieslist />} />
          <Route path="/create-sleep-story" element={<CreateSleepStory />} />
          <Route path="/edit-sleep-story/:id" element={<CreateSleepStory />} />
          <Route path="/screens" element={<ScreenList />} />
          <Route path="/create-screens" element={<CreateScreen />} />
          <Route path="/edit-screens/:id" element={<CreateScreen />} />
          <Route path="/journals" element={<JournalsList />} />
          <Route path="/background-music-list" element={<MusicList />} />
          <Route path="/create-background-music" element={<CreateMusic />} />
          <Route path="/edit-background-music/:id" element={<CreateMusic />} />
          <Route path="/subscriptions" element={<SubscriptionList />} />
          <Route
            path="/product/add-form"
            element={<AddDynamicForm type="add" />}
          />
          <Route
            path="/decision-tree"
            element={<AddScoreForm />}
          />
          <Route
            path="/product/edit-form/:id"
            element={<AddDynamicForm type="edit" />}
          />
          <Route
            path="/questionnaire"
            element={<AddDynamicForm type="view" />}
          />
        </Route>
  

      {/* Auth routes */}
      <Route element={<PublicRoute />}>
        <Route path="/sign-in/" element={<SignIn />} />
        <Route path="/page-404" element={<Page404 />} />
      </Route>
    </Routes>
  );
};

export default App;
